import { Button, Space, Drawer } from "antd";
import ReactToPrint from "react-to-print";
import {
  AiOutlineClose,
  AiOutlineCloseSquare,
  AiOutlinePrinter,
} from "react-icons/ai";
import { useRef } from "react";
import Moment from "react-moment";
import logo from "../../../assets/images/logo-red.png";
import "../../../assets/css/custom.css";
import { slice } from "lodash";
import { BsCheck2Square } from "react-icons/bs";

export default function DayCalendarPanel({
  isVisible,
  setVisible,
  attendance,
  training,
}: any) {
  const docRef = useRef(null);


  const data = new Array(22).fill({ id: 1 });
  let empties = slice(data, 0, 22 - attendance?.data?.length);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">Attendance</span>
        </div>
      }
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" color="blue">
            <ReactToPrint
              trigger={() => {
                return (
                  <button className="flex justify-center items-center focus:outline-none hover:text-red-500 mr-2">
                    <AiOutlinePrinter className="mr-2" /> Print
                  </button>
                );
              }}
              content={() => docRef.current}
              documentTitle={`Attendance`}
            />
          </Button>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="px-4">
        <div className="book border shadow-lg" id="invoice-doc" ref={docRef}>
          <div className="page">
            <div className="subpage">
              <div className="bg-gray-200 border-b border-t border-r border-l border-black mb-2 flex text-xs">
                <div className="flex items-center p-2 w-full">
                  <div className="border-r-2 border-black pr-2">
                    <img src={logo} width={100} height={100} alt="" />
                  </div>
                  <div className="ml-3 w-full">
                    <div className="flex justify-between w-full">
                      <div className="flex-1 text-2xl">
                        TRAINING ATTENDANCE SHEET
                      </div>
                      <div className="text-2xl uppercase font-bold pl-4">
                        <Moment format="Do MMM YYYY">{attendance?.date}</Moment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-2">
                <div className="border border-black p-1 bg-gray-200">
                  NAME OF THE TRAINING PROGRAMME
                </div>
                <div className="border border-black p-1 font-bold">
                  {training?.title}
                </div>
              </div>
              <div className="">
                <div className="border-t border-r border-l border-black p-2">
                  LIST OF PARTICIPANTS
                </div>

                {/* HEADER */}
                <div className="border border-black flex justify-between font-bold">
                  <div className="flex ">
                    <div className="w-10 p-1 border-r border-black">S/N</div>
                    <div className="w-40 p-1 border-r border-black">NAME</div>
                  </div>
                  <div className="w-40 p-1 border-l text-center border-black">
                    STATUS
                  </div>
                </div>

                {/* ATTENDEES */}
                <div className="mb-4">
                  {attendance?.data?.map((item: any, index: number) => (
                    <div className="border-r border-l border-b border-black flex justify-between" key={index}>
                      <div className="flex">
                        <div className="w-10 h-6 p-1 border-r border-black">
                          {index + 1}.
                        </div>
                        <div className="w-40 p-1 border-r border-black">
                          {item?.name}
                        </div>
                      </div>
                      <div className="w-40 p-1 border-l text-center border-black">
                        <div className="w-32 ml-4">
                          {item?.attended ? (
                            <div className="flex justify-start items-center ">
                              <BsCheck2Square size={22} color="#16a34a" />
                              <span className="ml-2">PRESENT</span>
                            </div>
                          ) : (
                            <div className="flex justify-start items-center">
                              <AiOutlineCloseSquare size={24} color="#dc2626" />
                              <span className="ml-2">ABSENT</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  {empties?.map((_: any, index: number) => (
                    <div
                      className="border-r border-l border-b border-black flex justify-between"
                      key={index}
                    >
                      <div className="flex">
                        <div className="w-10 h-6 p-1 border-r border-black text-white"></div>
                        <div className="w-40 p-1 border-r border-black"></div>
                      </div>
                      <div className="w-40 p-1 border-l text-center border-black"></div>
                    </div>
                  ))}
                </div>

                {/* SIGNATURE */}
                <div className="">
                  <div className="border border-black flex justify-between px-2">
                    <div className="">TRAINER'S SIGNATURE</div>
                    <div className="border-l border-black px-2 w-60">
                      ORGANIZER'S SIGNATURE
                    </div>
                  </div>
                  <div className="border border-black flex justify-between px-2">
                    <div className="h-10"></div>
                    <div className="border-l border-black px-2 w-60"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
